<template>
    <div class="department">
        <Head-view :showStyle="-1"></Head-view>
        <div class="main">
            <div class="breadcrumb">
                <div class="breadcrumbLeft">任务看板</div>
                <div class="breadcrumbRight">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="全屏展示"
                        placement="top-start"
                    >
                        <i class="el-icon-full-screen" @click="wholeShow()"></i>
                    </el-tooltip>
                </div>
            </div>

            <div class="showTba">
                <div class="listSum">
                    <div
                        class="listBox"
                        v-for="(item, key) in navSeeData"
                        :key="key"
                    >
                        <div class="boxLeft" :class="[item.styleIco]"></div>
                        <div class="boxRight">
                            <p
                                class="boxNumber"
                                :class="[
                                    item.type == 'inspectExceptionCount' ||
                                    item.type == 'unhandledFaultCount'
                                        ? 'colorRed'
                                        : '',
                                    item.type == 'handledFaultCount' ||
                                    item.type == 'todayDoneTaskCount'
                                        ? 'colorGreen'
                                        : '',
                                ]"
                            >
                                {{ item.number }}
                            </p>
                            <p class="boxFont">
                                {{ item.title }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="inspectionHistory" v-if="todayTaskArr.length > 0">
                    <div
                        class="historyBox"
                        v-for="(item, key) in todayTaskArr"
                        :key="key"
                    >
                        <div class="soptImg">
                            <img
                                v-if="item.routePicture"
                                :src="item.routePicture"
                                alt=""
                            />
                            <img
                                v-if="!item.routePicture"
                                src="../../assets/routerDefaultImg.png"
                                alt=""
                            />
                        </div>
                        <div class="soptMsg">
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="item.taskName"
                                placement="top"
                            >
                                <p class="soptName">{{ item.taskName }}</p>
                            </el-tooltip>

                            <p class="soptUser">
                                {{ item.staffName }}({{ item.staffDept }})
                            </p>
                            <p class="soptTime">{{ item.taskInspectTime }}</p>
                        </div>
                        <div class="soptProgress">
                            <div
                                class="conter"
                                v-for="(val, k) in item.placeList"
                                :key="k"
                            >
                                <div class="soptPlace">
                                    <img
                                        src="../../assets/taskPanel/success.png"
                                        alt=""
                                        v-if="val == 1"
                                    />
                                    <img
                                        src="../../assets/taskPanel/error.png"
                                        alt=""
                                        v-if="val != 1"
                                    />
                                </div>
                                <div
                                    class="router"
                                    v-if="k != item.placeList.length - 1"
                                ></div>
                            </div>
                        </div>
                        <div
                            v-if="
                                item.status != 3 &&
                                item.status != 4 &&
                                item.status != 5
                            "
                            class="soptStatus"
                            :class="[
                                item.status == 1 ? 'statusIco_notStart' : '',
                                item.status == 2
                                    ? 'statusIco_loadingStart'
                                    : '',
                                item.status == 3 ? 'statusIco_start' : '',
                                item.status == 4 ? 'statusIco_OK' : '',
                                item.status == 5 ? 'statusIco_fault' : '',
                                item.status == 6 ? 'statusIco_toTime' : '',
                            ]"
                        ></div>
                        <div class="soptStatus" v-if="item.status == 3">
                            <img
                                :class="[
                                    item.taskTimeOut
                                        ? 'imgcenterTrue'
                                        : 'imgcenterFalse',
                                ]"
                                src="../../assets/taskPanel/btnInspectionStart.png"
                                alt=""
                            />
                            <img
                                v-if="item.taskTimeOut"
                                src="../../assets/taskPanel/btnInspectionToTime.png"
                                alt=""
                            />
                        </div>
                        <div
                            class="soptStatus"
                            v-if="item.status == 4 || item.status == 5"
                        >
                            <img
                                :class="[
                                    item.taskTimeOut
                                        ? 'imgcenterTrue'
                                        : 'imgcenterFalse',
                                ]"
                                v-if="item.status == 4"
                                src="../../assets/taskPanel/btnIcspectionOK.png"
                                alt=""
                            />
                            <img
                                :class="[
                                    item.taskTimeOut
                                        ? 'imgcenterTrue'
                                        : 'imgcenterFalse',
                                ]"
                                v-if="item.status == 5"
                                src="../../assets/taskPanel/btnInspectionFault.png"
                                alt=""
                            />
                            <img
                                v-if="item.taskTimeOut"
                                src="../../assets/taskPanel/btnInspectionToTimes.png"
                                alt=""
                            />
                        </div>
                    </div>
                </div>

                <div class="inspectionHistory" v-if="todayTaskArr.length == 0">
                    <div class="taskNull">
                        <img src="../../assets/taskPanel/taskNull.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
import { getTime } from "../../untils/tools";
export default {
    name: "department",
    data() {
        return {
            dataIns: {},
            insId: "",

            navSeeData: [
                {
                    styleIco: "peopleIco",
                    title: "人员",
                    number: 0,
                    type: "staffCount",
                },
                {
                    styleIco: "inspectionTaskIco",
                    title: "巡检任务",
                    number: 0,
                    type: "taskCount",
                },
                {
                    styleIco: "inspectionRouteIco",
                    title: "巡检路线",
                    number: 0,
                    type: "routeCount",
                },
                {
                    styleIco: "inspectionSoptIco",
                    title: "巡检点位",
                    number: 0,
                    type: "placeCount",
                },
                {
                    styleIco: "inspectionHistoryIco",
                    title: "巡检记录",
                    number: 0,
                    type: "inspectCount",
                },
                {
                    styleIco: "faultHistoryIco",
                    title: "异常记录",
                    number: 0,
                    type: "inspectExceptionCount",
                    //inspectExceptionCount
                },
                {
                    styleIco: "faultHandleIco",
                    title: "故障已处理",
                    number: 0,
                    type: "handledFaultCount",
                },
                {
                    styleIco: "faultHandleIco",
                    title: "故障待处理",
                    number: 0,
                    type: "unhandledFaultCount",
                },
                {
                    styleIco: "todayTaskIco",
                    title: "今日任务",
                    number: 0,
                    type: "todayTaskCount",
                },
                {
                    styleIco: "taskCompleteIco",
                    title: "今日已完成",
                    number: 0,
                    type: "todayDoneTaskCount",
                },
            ],

            todayTaskArr: [],
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"));
        this.taskPanelInfo();

        this.getTodayTaskInfo(); //获取今日任务列表
    },

    methods: {
        taskPanelInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "institution/getInsStatistic", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.navSeeData.forEach((item, k) => {
                            for (let key in res.data) {
                                if (item.type == key) {
                                    this.navSeeData[k]["number"] =
                                        res.data[key];
                                }
                            }
                        });

                        this.dataIns = res.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        getTodayTaskInfo() {
            let data = {
                token: this.getCookie(),
                insId: this.insId,
            };

            this.request
                .post(this.baseUrl + "task/getTodayTaskList", data)
                .then((res) => {
                    if (res.code == 0) {
                        let nowTime = new Date().getTime();
                        let dataArr = [];
                        res.data.forEach((item, key) => {
                            dataArr.push(item);
                            dataArr[key]["taskTimeOut"] = false;
                            if (item.status == 3) {
                                let taskTime = new Date(
                                    getTime(2) +
                                        " " +
                                        item.taskInspectTime.split("-")[1]
                                ).getTime();
                                if (nowTime > taskTime) {
                                    dataArr[key]["taskTimeOut"] = true;
                                }
                            } else if (item.status == 4 || item.status == 5) {
                                if (item.isTimeout) {
                                    dataArr[key]["taskTimeOut"] = true;
                                }
                            }
                        });
                        this.todayTaskArr = dataArr;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.code,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message({
                        type: "error",
                        message: "出错了，获取今日任务列表失败",
                    });
                });
        },

        wholeShow() {
            let routeUrl = this.$router.resolve({
                path: "/taskPanel/wholeTaskPanel",
            });
            window.open(routeUrl.href, "_blank");
        },
    },
};
</script>

<style lang="less" scoped>
.department {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
            height: 20px;
            clear: both;

            .breadcrumbLeft {
                float: left;
            }

            .breadcrumbRight {
                float: right;
                margin-right: 20px;
                font-size: 20px;
                line-height: 25px;
            }
        }
        .showTba {
            margin-top: 24px;
            padding: 24px 0px 0 0px;
            height: 692px;
            background: rgba(6, 21, 43, 0.9);
            overflow: hidden;
            .listSum {
                display: flex;
                flex-wrap: nowrap;
                justify-content: center;

                .listBox {
                    display: flex;
                    flex-direction: row;
                    margin: 0 10px;
                    width: 147px;
                    height: 80px;
                    overflow: hidden;
                    background: rgba(0, 95, 184, 0.29);

                    .boxLeft {
                        width: 50%;
                        height: 80px;
                        opacity: 0.3;
                    }

                    .boxRight {
                        width: 50%;
                        height: 80px;
                        .boxNumber {
                            margin: 0;
                            margin-top: 10px;
                            margin-right: 10px;
                            width: 90%;
                            font-size: 16px;
                            font-weight: bold;
                            color: rgba(25, 137, 250, 1);
                            text-align: right;
                        }
                        .boxFont {
                            margin: 0;
                            margin-top: 10px;
                            width: 90%;
                            font-size: 12px;
                            color: rgba(255, 255, 255, 0.7);
                            text-align: right;
                        }

                        .colorRed {
                            color: rgba(255, 87, 51, 1);
                        }

                        .colorGreen {
                            color: rgba(33, 199, 159, 1);
                        }
                    }

                    .peopleIco {
                        background: url("../../assets/taskPanel/peopleIco.png")
                            no-repeat -10px center;
                        background-size: 66px 66px;
                    }

                    .inspectionTaskIco {
                        background: url("../../assets/taskPanel/inspectionTaskIco.png")
                            no-repeat -10px center;
                        background-size: 66px 66px;
                    }

                    .inspectionRouteIco {
                        background: url("../../assets/taskPanel/inspectionRouteIco.png")
                            no-repeat -10px center;
                        background-size: 66px 66px;
                    }

                    .inspectionSoptIco {
                        background: url("../../assets/taskPanel/inspectionSoptIco.png")
                            no-repeat -10px center;
                        background-size: 66px 66px;
                    }

                    .inspectionHistoryIco {
                        background: url("../../assets/taskPanel/inspectionHistoryIco.png")
                            no-repeat -10px center;
                        background-size: 66px 66px;
                    }

                    .faultHistoryIco {
                        background: url("../../assets/taskPanel/faultHistoryIco.png")
                            no-repeat -10px center;
                        background-size: 66px 66px;
                    }

                    .faultHandleIco {
                        background: url("../../assets/taskPanel/faultHandleIco.png")
                            no-repeat -10px center;
                        background-size: 66px 66px;
                    }

                    .todayTaskIco {
                        background: url("../../assets/taskPanel/inspectionTaskIco.png")
                            no-repeat -10px center;
                        background-size: 66px 66px;
                    }

                    .taskCompleteIco {
                        background: url("../../assets/taskPanel/taskCompleteIco.png")
                            no-repeat -10px center;
                        background-size: 66px 66px;
                    }
                }
            }

            .inspectionHistory {
                margin: 10px 10px 0;
                padding: 25px 20px;
                height: 550px;
                overflow-y: auto;
                background: url("../../assets/taskPanel/conterBorder.png")
                    no-repeat 0 0;
                background-size: 100% 100%;

                .historyBox {
                    margin-bottom: 12px;
                    padding: 15px;
                    display: flex;
                    flex-direction: row;
                    height: 100px;
                    opacity: 1;
                    border: 1px solid rgba(79, 152, 255, 0.53);

                    .soptImg {
                        width: 100px;
                        height: 100px;
                        overflow: hidden;
                        img {
                            width: 100%;
                        }
                    }

                    .soptMsg {
                        margin-left: 10px;
                        width: 120px;

                        p {
                            margin: 0;
                            padding: 0;
                            padding-top: 8px;
                        }

                        .soptName {
                            width: 120px;
                            height: 24px;
                            font-size: 20px;
                            font-weight: 700;
                            color: rgba(25, 137, 250, 1);
                            text-align: left;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }

                        .soptUser {
                            width: 120px;
                            font-size: 16px;
                            font-weight: 700;
                            color: rgb(158, 147, 147);
                            text-align: left;
                        }

                        .soptTime {
                            font-size: 14px;
                            font-weight: 400;
                            color: rgb(158, 147, 147);
                            text-align: left;
                        }
                    }

                    .soptProgress {
                        margin: 0 10px;
                        width: calc((100% - 355px));
                        height: 100px;
                        overflow-x: auto;

                        .soptPlace {
                            float: left;
                            margin-top: calc((100px - 35px) / 2);
                            width: 35px;
                            height: 35px;

                            img {
                                width: 100%;
                            }
                        }

                        .router {
                            float: left;
                            margin-top: calc((100px - 2px) / 2);
                            width: 66px;
                            height: 0px;

                            border: 1px dashed rgba(33, 199, 159, 1);
                        }
                    }

                    .soptStatus {
                        width: calc(100% - calc(100% - 100px));

                        img {
                            margin: 0 auto;
                            width: 100px;
                            height: 32px;
                        }

                        .imgcenterFalse {
                            margin-top: calc((100px - 32px) / 2);
                        }

                        .imgcenterTrue {
                            margin-top: calc((100px - 68px) / 2);
                        }
                    }

                    .statusIco_OK {
                        background: url("../../assets/taskPanel/btnIcspectionOK.png")
                            no-repeat center center;
                        background-size: 100px 32px;
                    }

                    .statusIco_fault {
                        background: url("../../assets/taskPanel/btnInspectionFault.png")
                            no-repeat center center;
                        background-size: 100px 32px;
                    }

                    .statusIco_notStart {
                        background: url("../../assets/taskPanel/btnInspectionNotStart.png")
                            no-repeat center center;
                        background-size: 100px 32px;
                    }

                    .statusIco_loadingStart {
                        background: url("../../assets/taskPanel/btnInspectionLoadingStart.png")
                            no-repeat center center;
                        background-size: 100px 32px;
                    }

                    .statusIco_toTime {
                        background: url("../../assets/taskPanel/btnInspectionToTime.png")
                            no-repeat center center;
                        background-size: 100px 32px;
                    }

                    .statusIco_start {
                        background: url("../../assets/taskPanel/btnInspectionStart.png")
                            no-repeat center center;
                        background-size: 100px 32px;
                    }
                }

                .taskNull {
                    margin: 0 auto;
                    margin-top: 126px;
                    width: 238px;
                    height: 238px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
    }
}

.box {
    width: 400px;

    .top {
        text-align: center;
    }

    .left {
        float: left;
        width: 60px;
    }

    .right {
        float: right;
        width: 60px;
    }

    .bottom {
        clear: both;
        text-align: center;
    }

    .item {
        margin: 4px;
    }

    .left .el-tooltip__popper,
    .right .el-tooltip__popper {
        padding: 8px 10px;
    }
}
</style>